import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Firebase, currentUserRole, isProduction, isDemo, appConfig } from './../../util';

import { Redirect, withRouter } from 'react-router-dom';
import qs from 'qs';

// TYmhKA4V~X2CKs(A>
const DEV_PASSWORD = 'TYmhKA4V~X2CKs(A>';
const DEMO_PASSWORD = 'demoV$3289';

class Login extends Component {

  state = {
    email: '',
    password: '',
    loginError: null,
    loginMessage: null,
    demoPasswordRequired: false,
    demoPassword: '',
    //redirectToReferrer: false,
    syncingWithServer: false,
    resettingPassword: false,
    resetPasswordComplete: false,
    demoPasswordInvalid: false
  }

  componentDidMount(){
    this.emailInput.focus();

    //set resettingPassword if reset is true in url
    const params = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });

    let resettingPassword = false;
    let email = '';

    // console.log('parsed params: ', params);

    if(params.forgot){
      resettingPassword = true;
    }
    if(params.email){
      email = params.email;
      this.passwordInput.focus();
    }

    if(isDemo()){
      this.setState({
        demoPasswordRequired: true
      });
    }

    this.setState({
      email,
      resettingPassword
    });
  }

  prefillLogin(loginType){

    console.log('PREFILL LOGIN: ', loginType);

    switch(loginType){
      case 'superadmin':
        this.setState({
          email: 'prbaylog+superadmin@gmail.com',
          password: DEV_PASSWORD,
        }, () => {
          this.submitLoginForm();
        });
      break;
      case 'admin':
        this.setState({
          email: 'prbaylog+admin@gmail.com',
          password: DEV_PASSWORD,
        }, () => {
          this.submitLoginForm();
        });
      break;
      case 'salesleader':
        this.setState({
          email: 'prbaylog+salesleader@gmail.com',
          password: DEV_PASSWORD,
        }, () => {
          this.submitLoginForm();
        });
      break;
      case 'manager':
        this.setState({
          email: 'prbaylog+manager@gmail.com',
          password: DEV_PASSWORD,
        }, () => {
          this.submitLoginForm();
        });
      break;
      case 'manager2':
        this.setState({
          email: 'prbaylog+manager2@gmail.com',
          password: DEV_PASSWORD,
        }, () => {
          this.submitLoginForm();
        });
      break;
      case 'employee':
        this.setState({
          email: 'prbaylog+employee@gmail.com',
          password: DEV_PASSWORD,
        }, () => {
          this.submitLoginForm();
        });
      break;
      case 'employee2':
        this.setState({
          email: 'prbaylog+employee2@gmail.com',
          password: DEV_PASSWORD,
        }, () => {
          this.submitLoginForm();
        });
      break;
      case 'clinton':
      this.setState({
        email: 'clinton.tucker@mailinator.com',
        password: DEMO_PASSWORD,
      }, () => {
        this.submitLoginForm();
      });
      break;
      case 'carole':
      this.setState({
        email: 'carole.ward@mailinator.com',
        password: DEMO_PASSWORD,
      }, () => {
        this.submitLoginForm();
      });
      break;
      case 'kenneth':
      this.setState({
        email: 'kenneth.graves@mailinator.com',
        password: DEMO_PASSWORD,
      }, () => {
        this.submitLoginForm();
      });
      break;
      case 'lucy':
      this.setState({
        email: 'lucy.webb@mailinator.com',
        password: DEMO_PASSWORD,
      }, () => {
        this.submitLoginForm();
      });
      break;
    }
  }

  submitLoginForm(){

    this.setState({
      syncingWithServer: true,
      loginError: false
    });

    const {email, password} = this.state;

    Firebase.auth().signInWithEmailAndPassword(email, password).catch(error => {
      this.setState({
        syncingWithServer: false,
        loginError: error.message,
      });
    }).then(() => {
      //console.log('firebase signin THEN!');
      // this.setState({
      //   redirectToReferrer: true,
      // });
    });
  }

  submitResetPasswordForm(){
    this.setState({
      syncingWithServer: true,
      loginError: false
    });

    const {email} = this.state;

    Firebase.auth().sendPasswordResetEmail(email, {
      url: `${appConfig().APP_URL}/login?email=${encodeURIComponent(email)}`,
    }).then(() => {
      this.setState({
        resettingPassword: false,
        logingError: null,
        syncingWithServer: false,
        password: '',
        loginMessage: 'Password reset. Check your email.',
        resetPasswordComplete: true,
      })
    }).catch(error => {
      this.setState({
        syncingWithServer: false,
        loginError: error.message
      });
    });
  }

  getLoginButtonHtml(){
    return {
      __html: (this.state.syncingWithServer ? 'Logging in...' : 'Login')
    };
  }

  getResetPasswordButtonHtml(){
    return {
      __html: (this.state.syncingWithServer ? 'Resetting...' : 'Reset password')
    };
  }

  toggleResettingPassword(){
    this.setState({
      resettingPassword: !this.state.resettingPassword,
    });
  }

  handleSubmit(event){
    event.preventDefault();
    this.submitLoginForm();
  }

  validateDemoPassword(event){

    if(typeof event !== undefined){
      event.preventDefault();
    }

    if(this.state.demoPassword === 'talent'){
      this.setState({
        demoPassword: '',
        demoPasswordRequired: false,
        demoPasswordInvalid: false,
      });
    }
    else{
      this.setState({
        demoPasswordInvalid: true
      });
    }
  }

  bodyDemoPasswordForm(){
    const { demoPassword, demoPasswordError, demoPasswordInvalid } = this.state;

    return (
      <form onSubmit={this.validateDemoPassword.bind(this)}>
        <div className="velocity-form form-group-container page-form">
          <h2>Enter demo password</h2>
          {demoPasswordInvalid &&
            <div className="form-message error">Invalid password</div>
          }
          <div className="form-group">
            <label htmlFor="velocity-demo-password">Password</label>
            <input ref={input => { this.demoPasswordInput = input; }} id="velocity-demo-password" type="text" placeholder="Demo password" value={demoPassword} onChange={(e) => this.setState({ demoPassword: e.target.value }) } />
          </div>

          <div className="form-group">
            <button className="button secondary" onClick={this.validateDemoPassword.bind(this)}>SUBMIT</button>
          </div>

        </div>
      </form>
    );
  }

  bodyLoginForm(){

    const { email, password, syncingWithServer, loginError, loginMessage, resettingPassword, resetPasswordComplete } = this.state;

    return (
      <form onSubmit={this.handleSubmit.bind(this)}>
        <div className="velocity-form form-group-container page-form">
          {!resetPasswordComplete &&
            <h2>{resettingPassword ? 'Reset Password' : 'Login'}</h2>
          }
          {!isProduction() && !isDemo() && (document.location.origin === 'http://localhost:3000') && !resetPasswordComplete && !resettingPassword &&
            <template style={{marginBottom: '20px'}}>
              <h6 style={{color: '#545B72', marginTop: '0px', marginBottom:'5px'}}>QUICK LOGIN (DEVELOPMENT ONLY)</h6>
              <button type="button" style={{float: 'left', clear: 'none', margin: '5px 5px 5px 0'}} onClick={() => { this.prefillLogin('superadmin'); }} className="button grey-outline button-micro">SuperAdmin</button>
              <button type="button" style={{float: 'left', clear: 'none', margin: '5px 5px 5px 0'}} onClick={() => { this.prefillLogin('admin'); }} className="button grey-outline button-micro">Admin</button>
              <div style={{ position: 'relative', clear: 'both' }}></div>
              <button type="button" style={{float: 'left', clear: 'none', margin: '5px 5px 5px 0'}} onClick={() => { this.prefillLogin('salesleader'); }} className="button grey-outline button-micro">Sales Leader</button>
              <div style={{ position: 'relative', clear: 'both' }}></div>
              <button type="button" style={{float: 'left', clear: 'none', margin: '5px 5px 5px 0'}} onClick={() => { this.prefillLogin('manager'); }} className="button grey-outline button-micro">Manager</button>
              <button type="button" style={{float: 'left', clear: 'none', margin: '5px 5px 5px 0'}} onClick={() => { this.prefillLogin('manager2'); }} className="button grey-outline button-micro">Manager 2</button>
              <div style={{ position: 'relative', clear: 'both' }}></div>
              <button type="button" style={{float: 'left', clear: 'none', margin: '5px 5px 5px 0'}} onClick={() => { this.prefillLogin('employee'); }} className="button grey-outline button-micro">Employee</button>
              <button type="button" style={{float: 'left', clear: 'none', margin: '5px 5px 5px 0'}} onClick={() => { this.prefillLogin('employee2'); }} className="button grey-outline button-micro">Employee 2</button>
            </template>
          }
          {isDemo() && !resetPasswordComplete && !resettingPassword &&
            <template style={{marginBottom: '20px'}}>
              <h6 style={{color: '#545B72', marginTop: '0px', marginBottom:'5px'}}>QUICK LOGIN (DEMO ONLY)</h6>
              <button type="button" style={{float: 'left', clear: 'none', margin: '5px 5px 5px 0'}} onClick={() => { this.prefillLogin('clinton'); }} className="button grey-outline button-micro">Clinton (Manager)</button>
              <div style={{ position: 'relative', clear: 'both' }}></div>
              <button type="button" style={{float: 'left', clear: 'none', margin: '5px 5px 5px 0'}} onClick={() => { this.prefillLogin('carole'); }} className="button grey-outline button-micro">Carole (Rep)</button>
              <button type="button" style={{float: 'left', clear: 'none', margin: '5px 5px 5px 0'}} onClick={() => { this.prefillLogin('kenneth'); }} className="button grey-outline button-micro">Kenneth (Rep)</button>
              <button type="button" style={{float: 'left', clear: 'none', margin: '5px 5px 5px 0'}} onClick={() => { this.prefillLogin('lucy'); }} className="button grey-outline button-micro">Lucy (Rep)</button>
            </template>
          }
          {loginError &&
            <div className="form-message error">{loginError}</div>
          }
          {loginMessage &&
            <div className="form-message success">{loginMessage}</div>
          }
          {!resetPasswordComplete &&
            <div className="form-group">
              <label htmlFor="velocity-login-email">Email</label>
              <input ref={input => { this.emailInput = input; }} id="velocity-login-email" disabled={syncingWithServer} type="text" placeholder="Email" value={email} onChange={(e) => this.setState({ email: e.target.value }) } />
            </div>
          }
          {!resettingPassword && !resetPasswordComplete &&
            <div className="form-group">
              <label htmlFor="velocity-login-password">Password</label>
              <input ref={input => { this.passwordInput = input; }} id="velocity-login-password" disabled={syncingWithServer} type="password" placeholder="Password" value={password} onChange={(e) => this.setState({ password: e.target.value }) } />
            </div>
          }
          {!resettingPassword && !resetPasswordComplete &&
            <div className="form-group">
              <button className={'button primary' + (syncingWithServer ? ' disabled' : '')} disabled={syncingWithServer} onClick={this.submitLoginForm.bind(this)} dangerouslySetInnerHTML={this.getLoginButtonHtml()}></button>
            </div>
          }
          {resettingPassword && !resetPasswordComplete &&
            <div className="form-group">
              <button className={'button primary' + (syncingWithServer ? ' disabled' : '')} disabled={syncingWithServer} onClick={this.submitResetPasswordForm.bind(this)} dangerouslySetInnerHTML={this.getResetPasswordButtonHtml()}></button>
            </div>
          }
          {!resetPasswordComplete &&
            <div className="form-group">
              <p className="forgot-password actionable centered" onClick={this.toggleResettingPassword.bind(this)}>{resettingPassword ? 'Cancel' : 'Forgot password?'}</p>
            </div>
          }
        </div>
      </form>
    )
  }

  render() {

    let from = this.props.location.state && this.props.location.state.referrer ? this.props.location.state.referrer : false;

    const { demoPasswordRequired } = this.state;

    //set redirect page if no referrer based on user type
    if(!from || from === '/'){
      if(this.props.authenticated){
        if(currentUserRole() === 'employee'){
          from = '/sprint';
        }
        else if(currentUserRole() === 'manager'){
          from = '/teams';
        }
        else if(currentUserRole() === 'salesleader'){
          from = '/all-teams';
        }
        else if(currentUserRole() === 'admin'){
          from = '/people';
        }
        else{
          from = '/people';
        }
      }
    }

    //only redirect after user prop updates in store
    if (this.props.authenticated) {
      return <Redirect to={from} />
    }

    return (
      <div className="page login">
        {demoPasswordRequired && this.bodyDemoPasswordForm()}
        {!demoPasswordRequired && this.bodyLoginForm()}
      </div>
    )
  }
}

function mapStateToProps(state){
  return {
    user: state.user,
    authenticated: (state.user && state.user.uid) ? true : false
  }
}

export default withRouter(connect(mapStateToProps, {})(Login));



// WEBPACK FOOTER //
// ./src/components/login/index.js